// The other stress a word may have (rules/borrowed-stress.ts BORROWED_STRESS: a borrowing's own
// stress, Peterson's alternate pronunciation), as a stress display beside the regular one
// ("buz·DA·ri" beside "BUZ·da·ri", "da·OR" beside "DAOR"). The regular stress (phonology.ts
// stressDisplay) stays the main one, unless the row says `main` (daor: da·OR is the main display,
// DAOR beside it; `main` in the result).
import { stressDisplay, type StressDisplay } from './phonology';
import { BORROWED_STRESS, type BorrowedStress } from './rules/borrowed-stress';

/**
 * The other stress display of a word (with why: `kind`; `main`: it is the main display and the
 * regular one goes beside it), or undefined when it has none (or it equals the regular one).
 */
export function borrowedStressDisplay(word: string): (StressDisplay & { kind: NonNullable<BorrowedStress['kind']>; main: boolean }) | undefined {
  const w = word.normalize('NFC');
  const row = BORROWED_STRESS.find((r) => r.word === w.toLocaleLowerCase('en'));
  if (!row) return undefined;
  const regular = stressDisplay(w);
  const kind = row.kind ?? 'borrowing';
  // its own syllable split, in the word's own letters (case kept)
  let syllables = regular.syllables;
  if (row.syllables) {
    if (row.syllables.join('') !== row.word) return undefined;
    let at = 0;
    syllables = row.syllables.map((s) => w.slice(at, (at += s.length)));
  }
  const sameSplit = syllables.length === regular.syllables.length && syllables.every((s, i) => s === regular.syllables[i]);
  if (row.stressed >= syllables.length || (sameSplit && row.stressed === regular.stressed)) return undefined;
  const display = syllables.map((s, i) => (i === row.stressed ? s.toUpperCase() : s)).join('·');
  return { ...regular, syllables, stressed: row.stressed, display, ...(sameSplit ? {} : { weights: [] }), kind, main: !!row.main };
}
